import AdminLanguagesPage from './AdminLanguagesPage'
export default AdminLanguagesPage;